import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ModalService } from 'src/app/services/modal/modal.service';
import { RechercheMultiService } from 'src/app/services/recherche/recherche-multi.service';
import { RechercheMultiCriteres } from 'src/app/utils/interfaces/new/recherche';

@Component({
  selector: 'app-recherche-multi-save',
  templateUrl: './recherche-multi-save.fragment.html',
  styleUrls: ['./recherche-multi-save.fragment.scss', '../modal.fragment.scss'],
})

export class RechercheMultiSaveFragment implements OnInit {
  public formGroup: FormGroup;
  public header = '';
  public errorMessage = ''; 
  public isEdit = false;
  public refreshStream: Subject<any>;
  public recherche: RechercheMultiCriteres;
  public isSubmitDisabled: boolean = false;

  @Output() public closeEmitter = new EventEmitter();

  constructor(
    private _formBuilder: FormBuilder,
    public viewContainerRef: ViewContainerRef,
    public modalService: ModalService,
    private rechercheSvc: RechercheMultiService
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      titre: ['', Validators.required]
    });
    if (this.recherche.id) {
      this.isEdit = true;
    }
    if (this.recherche.titre) {
      this.formGroup.controls['titre'].setValue(this.recherche.titre);
    }
  }

  public async onSubmit(): Promise<void> {
    this.isSubmitDisabled = true;
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      try {
        this.recherche.titre = this.formGroup.controls['titre'].value;
        if (this.isEdit) {
          this.rechercheSvc.updateRecherche(this.recherche);
        } else {
          this.rechercheSvc.saveRecherche(this.recherche);
        }
        this.closeRechercheModal();
      } catch(error) {
        console.error(error);
        this.errorMessage = error;
      }
    } else {
      this.isSubmitDisabled = false;
    }
  }

  public closeRechercheModal(): void {
    this.closeEmitter.emit(null);
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}
